export default __webpack_public_path__ + "static/game-theory-desktop-burn-b92101875f1cbf0dff68fa6f1e098bd1.svg";